export default "__VITE_PUBLIC_ASSET__6dd7c9ea__"